<!--
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2022-10-26 14:52:50
 * @LastEditors: pj
 * @LastEditTime: 2022-11-16 10:02:42
-->
<template>
    <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">

        <a-form-item label="平台类型">
            <platformSelecter :isDisabled="false" :showAll='true' v-model="searchP.platformtype" @platformTypeChange="handleSubmit"></platformSelecter>
        </a-form-item>
        <a-form-item label="用户ID">
            <a-input v-model="searchP.userid" placeholder="输入用户ID"></a-input>
        </a-form-item>
        <a-form-item label="用户名称">
            <a-input v-model="searchP.fullname" placeholder="输入用户名称"></a-input>
        </a-form-item>
        <a-form-item label="用户标签">
            <a-input v-model="searchP.tag" placeholder="输入用户标签"></a-input>
        </a-form-item>
        <a-form-item label="业务编码">
            <a-input v-model="searchP.platformcode" placeholder="输入业务编码"></a-input>
        </a-form-item>
        <a-form-item>
            <a-button type="primary" @click="handleSubmit">查询</a-button>
        </a-form-item>
    </a-form>
</template>

<script>
import platformSelecter from '../../components/platformSelecter'

export default {
    components: {
        platformSelecter,
    },
    data() {
        return {
            form: this.$form.createForm(this),
            searchP: {
                userid: '',
                fullname: '',
                tag: '',
                platformtype: '',
                platformcode: '',
            },
        }
    },
    methods: {
        handleSubmit() {
            this.$emit('handleSearch', this.searchP)
        },
    },
    mounted() {},
}
</script>

<style>
.myform {
    margin-bottom: 20px;
}
</style>

